import { FC, PropsWithChildren, useState, useEffect } from 'react';
import { CoreContext } from 'modules/intelligentInsights/frequencyOptimization/contexts/CoreContext';
import { isEmpty } from 'lodash';
import { useFroInsightsSearchParams } from 'modules/intelligentInsights/frequencyOptimization/hooks/useFroInsightsSearchParams';
import {
  FroInsightsData,
  PerformanceOverTimeLift,
} from 'modules/intelligentInsights/frequencyOptimization/types';
import { useLazyGraphql } from 'utils/hooks/useLazyGraphql';
import { defaultContext } from 'modules/intelligentInsights/frequencyOptimization/contexts/CoreContext';
import { getFrequencyReporting } from 'modules/intelligentInsights/frequencyOptimization/graphql/getFrequencyReporting';
import { TimespanEnum } from 'modules/intelligentInsights/types';
import { FrequencyOptimizationInsightsResponse } from 'modules/intelligentInsights/frequencyOptimization/types';
import { createCoreFetchVars } from 'modules/intelligentInsights/domain.utils';

export const CoreContextProvider: FC<PropsWithChildren<unknown>> = ({ children }) => {
  const { data, error, fetch, isLoading } = useLazyGraphql<FrequencyOptimizationInsightsResponse>(
    getFrequencyReporting,
    {
      notifyOnNetworkStatusChange: true,
    },
  );
  const [selectedTimespan, setTimespan] = useState(TimespanEnum.Thirty);

  // biome-ignore lint/correctness/useExhaustiveDependencies:
  useEffect(() => {
    fetch(createCoreFetchVars(TimespanEnum.Thirty));
  }, []);

  const { selectedTab, setSelectedTab } = useFroInsightsSearchParams();
  const [selectedLiftTab, setSelectedLiftTab] = useState<PerformanceOverTimeLift>(
    PerformanceOverTimeLift.Open,
  );

  const dataLoaded = !isEmpty(data);
  let isReady = false;
  isReady = !isLoading && !error && dataLoaded;

  return (
    <CoreContext.Provider
      value={{
        fetchCoreData: (nextTimespan: TimespanEnum) => fetch(createCoreFetchVars(nextTimespan)),
        froInsightsData: dataLoaded
          ? (data?.optimizeFrequencyReporting as FroInsightsData)
          : defaultContext.froInsightsData,
        isLoading,
        isError: error,
        isReady,
        selectedMedium: selectedTab,
        setSelectedMedium: setSelectedTab,
        selectedLiftTab,
        setSelectedLiftTab,
        timeSpan: {
          selectedTimespan,
          updateTimespan: (nextTimespan: TimespanEnum) => {
            setTimespan(nextTimespan);
            fetch(createCoreFetchVars(nextTimespan));
          },
        },
      }}
    >
      {children}
    </CoreContext.Provider>
  );
};
